import { Component, Input} from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { ContractDataService } from '../../services/contract-data.service';
import { IContractDataModel } from '../../models/contract-internal-models';
import { ContractFormService } from '../../services/contract-form.service';
import { HelpersService } from '../../../../services/helpers.service';
import { ContractRoadmapModel } from '../../../../models/contract.model';

@Component({
    selector: 'app-contract-history-list',
    templateUrl: './contract-history-list.component.html',
    styleUrl: './contract-history-list.component.scss',
 
})
export class AppContractHistoryListComponent {
  @Input() contractGuid:string = '' 
  private subs:Subscription = new Subscription
  public roadMapHistory:ContractRoadmapModel[] = [] 
  public savedCountLabel:string = ''
  public selectedRoadMap:string = ''
  public userNamesMap:Map<string,string> = new Map()
  public dateLabelsMap:Map<string,string> = new Map()
  public monthNames = ['января, ', 'февраля, ', 'марта, ', 'апреля, ', 'мая, ', 'июня, ','июля, ' , 'августа, ', 'сентября, ', 'октября, ', 'ноября, ', 'декабря, '
            ]
  constructor(
    private contractFormService:ContractFormService,
    private contractDataService:ContractDataService,
    private helpersService:HelpersService
  ){}
  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }
  ngOnInit(): void {
    this.setHistoryData()
    this.subs.add(this.contractDataService.bSubContractDataIsCached.asObservable()
    .pipe(filter(data=>data.guid === this.contractGuid))
    .subscribe(()=>this.setHistoryData()))
  }
  setHistoryData() {
    let contractData = this.contractDataService.ContractDataCachedByGuid.get(this.contractGuid)
    this.roadMapHistory = contractData?.contract?.roadmap_history||[]
    this.roadMapHistory.forEach(el=>this.userNamesMap.set(el.creator.guid,this.helpersService.shortFullName(el.creator)))
    this.savedCountLabel = this.setSavedCountLabel(this.roadMapHistory.length)
    this.setDateLabels()
  }
  setSavedCountLabel(count:number):string {
    switch (true==true) {
      case count == 1: return ' сохранение'
      case [2,3,4].includes(count): return ' сохранения'
      case count>=5: return ' сохранений'
      default: return ''
    }
  }
  setDateLabels(){
    this.roadMapHistory.forEach((el,index)=>{
      let createdDate = new Date(el.created_at)
      let yearLabel = createdDate.getFullYear() === new Date().getFullYear()? '' : createdDate.getFullYear() + ', '
      let dateLabel ='' + yearLabel  + createdDate.getDay() +' ' + (this.monthNames[createdDate.getMonth()]) + createdDate.getHours()+':'+createdDate.getMinutes()
      index === 0? dateLabel = createdDate.getHours()+':'+createdDate.getMinutes() : null
      this.dateLabelsMap.set(el.guid,dateLabel)
    })
  }
  selectRoadMap(roadMap:ContractRoadmapModel) {
    this.selectedRoadMap = roadMap.guid
  }
  restoreRoadMap(){
    let roadmap = this.roadMapHistory.find(el=>el.guid === this.selectedRoadMap)
    let label = roadmap?.guid? this.dateLabelsMap.get(roadmap.guid)||'' : ''
    roadmap? this.contractDataService.subRoadMapSelected.next({label: label,roadmap:roadmap}) : null
  }
  cancelAction() {
    this.selectedRoadMap = this.roadMapHistory[0].guid
    this.restoreRoadMap()
    this.contractFormService.showHistoryList = false
  }
}